import cache from "@pcloud/web-utilities/dist/api/cache";

const globalCache = cache;

export default globalCache;
